export enum Routes {
  PROJECTS = "projects"
}

interface ProjectsRouteData {
  currentPage: string;
}

export interface RoutesStorageInterface {
  [Routes.PROJECTS]: ProjectsRouteData;
}
